var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.375 0.0117188C8.07031 0.0117188 7.80859 0.121094 7.58984 0.339844L3.79297 4.125L3.51172 5.55469L3.39453 6.10547L3.94531 5.98828L5.375 5.70703L9.16016 1.91016C9.37891 1.69141 9.48828 1.42969 9.48828 1.125C9.48828 0.820312 9.37891 0.558594 9.16016 0.339844C8.94141 0.121094 8.67969 0.0117188 8.375 0.0117188ZM8.375 0.738281C8.46094 0.738281 8.54688 0.78125 8.63281 0.867188C8.71875 0.953125 8.76172 1.03906 8.76172 1.125C8.76172 1.21094 8.71875 1.29688 8.63281 1.38281L5 5.01562L4.35547 5.14453L4.48438 4.5L8.11719 0.867188C8.20312 0.78125 8.28906 0.738281 8.375 0.738281ZM0.5 1.5V9H8V4.05469L7.25 4.80469V8.25H1.25V2.25H4.69531L5.44531 1.5H0.5Z",
    fill: "#089BAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconSmall);
export default __webpack_public_path__ + "static/media/edit-icon-small.fa2c53ac3d245edb090e207618c8f583.svg";
export { ForwardRef as ReactComponent };